export interface IPackageRequest {
	id: number;
	title: string;
	description: string;
	images: string[];
	stars: number | null;
	feedback: string | null;
	ticket_id: number;
	factor_price: number;
	campaign_id: number;
	created_at: string;
	reject_reason?: string;
	final_result: { [key: string]: string } | null;
	package: IPackage;
}

export interface IPackage {
	id: number;
	title: string;
	image: string;
	category: string;
	media: string;
	content_type: string;
	quality: string;
	company_title: string;
	price: number;
	requirement_title: string;
	requirement_description: string;
	rules: string;
	status: OrderStatus;
}

export enum TYPE_STUDIO {
	Pending = 'pending', // Awaiting completion
	PaymentPend = 'payment_pend',
	ConfirmationPend = 'confirmation_pend',
	QueueUp = 'queue_up',
	InProgress = 'in_progress',
	Completed = 'completed',
	Rejected = 'rejected',
}

export type OrderStatus = 'pending' | 'payment_pend' | 'confirmation_pend' | 'queue_up' | 'in_progress' | 'completed' | 'rejected';

export interface IOrder {
	id: number;
	title: string;
	media: string;
	content_type: string;
	created_at: Date;
	finished_at: Date | null;
	status: OrderStatus;
}
